import { ref } from 'vue'
import { auth, signInWithEmailAndPassword } from '@/firebase/config'

const error = ref(null)

const login = async (email, password) => {
  error.value = null

  // try {
  // INTERNAL TIMER MAY CAUSE EXTRA ERROR IN THE CONSOLE WHEN USING AWAIT
  // FIREBASE WILL OVERHAUL IN THE FUTURE & EVERYTHING STILL WORKS
  // const res = await auth.signInWithEmailAndPassword(email, password)
  // error.value = null
  // return res

  signInWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
    // Signed in
      const user = userCredential.user
      error.value = null
      return user
    })
    .catch((err) => {
      console.log(err.message, err.code)
      // error.value = err.message
      error.value = 'Login Error: User not found, try again'
    })
}

const useLogin = () => {
  return { error, login }
}

export default useLogin
